import React from "react"
import { RenderNode, PropsType, RenderText, HtmlRenderProps } from "./types"
import { parseHtmlToComponents } from "./parser"

const defaultRenderNode: RenderNode = (
  nodeName: string,
  props: PropsType | undefined,
  children?: React.ReactNode,
): React.ReactNode => {
  return React.createElement(nodeName, props, children)
}

const defaultRenderText: RenderText = (text: string | null) => text

export function HtmlRender({ html, renderNode, renderText }: HtmlRenderProps) {
  const components = parseHtmlToComponents(html, {
    renderNode: renderNode || defaultRenderNode,
    renderText: renderText || defaultRenderText,
  })

  // fallback to dangerouslySetInnerHTML if it failed to parse html
  if (!components) {
    return <div dangerouslySetInnerHTML={{ __html: html }} />
  }

  return <>{components}</>
}
